var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperienceFeaturesIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9916 13.0001C24.9214 13.0021 24.8537 13.0213 24.787 13.0513L16.3325 16.5967C16.1856 16.6605 16.0699 16.7922 16.0256 16.9461C15.5152 18.6999 15.1819 20.234 15.1819 22.2813C15.1819 29.3693 19.4024 35.5372 24.8637 36.9828C24.9527 37.0058 25.0475 37.0058 25.1365 36.9828C30.5978 35.5372 34.8183 29.3693 34.8183 22.2813C34.8183 20.234 34.485 18.6999 33.9746 16.9461C33.9303 16.7922 33.8146 16.6605 33.6677 16.5967L25.2132 13.0513C25.1345 13.0139 25.0618 12.9983 24.9916 13.0001ZM25.0001 14.1422L32.9944 17.5001C33.4466 19.0926 33.7274 20.4499 33.7274 22.2813C33.7274 28.869 29.7794 34.5298 25.0001 35.8834C20.2208 34.5298 16.2728 28.869 16.2728 22.2813C16.2728 20.4499 16.5535 19.0926 17.0057 17.5001L25.0001 14.1422ZM25.0001 20.3637C24.6988 20.3637 24.4546 20.6079 24.4546 20.9091V24.1819H21.1819C20.8806 24.1819 20.6364 24.426 20.6364 24.7273C20.6364 25.0285 20.8806 25.2727 21.1819 25.2727H24.4546V28.5455C24.4546 28.8467 24.6988 29.0909 25.0001 29.0909C25.3013 29.0909 25.5455 28.8467 25.5455 28.5455V25.2727H28.8183C29.1195 25.2727 29.3637 25.0285 29.3637 24.7273C29.3637 24.426 29.1195 24.1819 28.8183 24.1819H25.5455V20.9091C25.5455 20.6079 25.3013 20.3637 25.0001 20.3637Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 49.5,
    height: 49.5,
    rx: 3.75,
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienceFeaturesIcon2);
export default __webpack_public_path__ + "static/media/experience_features_icon2.8b10289a9f4304520dcfc4a65760414a.svg";
export { ForwardRef as ReactComponent };